<template>
  <div>
    <div class="leftheader">
      <div>
        <img src="@/assets/images/dynamic.png" alt />
        <span>培训班动态</span>
      </div>
      <div class="gitern"></div>
    </div>
    <div class="leftnMetter">
      <div class="traindataheader">
        <div style="width:250px">调训班名称</div>
        <div style="width:100px">类型</div>
        <div style="width:120px">部门</div>
        <div style="width:110px">警种</div>
        <div style="width:180px">培训进度</div>
        <div style="width:200px">培训时间</div>
      </div>

      <div class="dynamicTableCon">
        <div
          class="traindata"
          v-for="(item,index) in traindata"
          :key="index"
          @click="trainclass(item.id)"
        >
          <el-tooltip v-if="item.title.length > 11" effect="dark" :content="item.title" placement="right-start">
            <div style="width:250px;text-align: left;padding-left: 10px;" class="slue">{{item.title}}</div>
          </el-tooltip>
          <div v-else style="width:250px;text-align: left;padding-left: 10px;" class="slue">{{item.title}}</div>
          <el-tooltip v-if="item.cateDicName.length > 5" effect="dark" :content="item.cateDicName" placement="right-start">
            <div style="width:100px;text-align: center;" class="slue">{{item.cateDicName}}</div>
          </el-tooltip>
          <div v-else style="width:100px;text-align: center;" class="slue">{{item.cateDicName}}</div>
          <div style="width:120px;text-align: center;box-sizing: border-box;padding: 0px 10px;" class="slue">{{item.deptname}}</div>
          <div style="width:110px;text-align: center;" class="slue">{{item.jzDicName}}</div>
          <div style="width:180px;text-align: center;" class="traindatafour">
            <div style="width: 100%;box-sizing: border-box;padding: 0px 10px;">
              <el-progress :percentage="item.percentage?item.percentage:0" :stroke-width="7" style="margin-top:10px;"></el-progress>
            </div>
          </div>
          <div
            style="width:200px;text-align: center;font-size: 14px;"
            class="slue"
          >{{item.startime?item.startime.substring(0, 10):''}} ~ {{item.endtime?item.endtime.substring(0, 10):""}}</div>
        </div>
      </div>
    </div>
    <div class="pageblock">
      <el-pagination
        background
        prev-text="上一页"
        next-text="下一页"
        layout="total,prev, pager, next,jumper"
        :page-size="listQuery.limit"
        :current-page.sync="listQuery.page"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import * as trainApi from '@/api/train/index';
export default {
  props: ['listQuery'],
  data() {
    return {
      policeClassification: [{ name: '全部', id: 0 }], //全部警种
      policeClassindex: 0, //高亮默认为全部
      traindata: [],
      total: 0,
    };
  },
  created() {
    this.getPmiDictionary(1, this.policeClassification);
    this.getList();
  },
  methods: {
    getList() {
      trainApi.getSearchList(this.listQuery).then((res) => {
        this.traindata = res.data;
        this.total = res.count;
      });
    },
    trainclass(id) {
      this.$router.push({
        path: '/train/trainclass',
        query: {
          id: id,
        },
      });
    },
    policeClassArea(index, item) {
      this.policeClassindex = index;
      if (item.id == 0) {
        this.listQuery.JzDicId = null;
      } else {
        this.listQuery.JzDicId = item.id;
      }
      this.getList();
    },
    getPmiDictionary(index, arr) {
      let listQuery = {
        namespaceId: index,
        page: 1,
        limit: 50,
      };
      trainApi.getPmiDic(listQuery).then((response) => {
        response.result.forEach((e) => {
          arr.push({ name: e.name, id: e.id });
        });
      });
    },
    // 分页组件的页数跳转方法
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.leftheader > div:nth-child(1) {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 14px 0px 5px 31px;
  &>img{
    height: 40px;
    width: 40px;
    margin-right: 20px;
  }
  &>span{
    color: #000000;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
  }
}

.leftnMetter {
  height: 780px;
  box-sizing: border-box;
  padding: 0px 29px;
}

.dynamicTableCon{
  overflow:auto;
  height:780px;
  width:100%;
}

.heightlight {
  background-color: rgba(72, 118, 196, 0.95) !important;
  color: #f8fafc !important;
}

.traindataheader {
  height: 50px;
  display: flex;
  line-height: 50px;
  font-size: 16px;
  color: #999999;
}
.traindataheader > div {
  text-align: center;
}
.traindata {
  display: flex;
  height: 36px;
  line-height: 36px;
  border-bottom: solid 1px #f2f2f2;
  cursor: pointer;
  font-size: 16px;
}
.traindata > div {
  text-align: center;
}
.traindata:hover {
  background-color: #f5f7fa;
}
.pageblock {
  margin-top: 30px;
  text-align: center;
}

.slue {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.gitern {
  height: 2px;
  width: 100%;
  background: linear-gradient(139deg, #1492ff, #d51919);
}
</style>
<style scoped>
.traindatafour /deep/.el-progress-bar__inner {
  background: linear-gradient(
    to right,
    rgb(58, 143, 255),
    rgb(37, 211, 104)
  ) !important;
}

.traindatafour /deep/.el-progress .el-progress__text{
  font-size: 14px !important;
}
</style>